import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    label: {
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
}));
